import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class ToggleDisplay extends Component {

  render() {
    let inner = <div></div>;

    if (this.props.show) {
      inner = (
        <div  className={this.props.className} style={this.props.style}>
        {this.props.children}
        </div>
      );

    }

    return (
      <div>
      {inner}
      </div>
    )
  }
}

ToggleDisplay.PropTypes = {
  show: PropTypes.bool
}

ToggleDisplay.defaultProps = {
  show:false,
};



// WEBPACK FOOTER //
// ./src/components/ToggleDisplay.js